import React, { useState } from "react";
import { ScrollMenu, VisibilityContext } from "react-horizontal-scrolling-menu";
import { ServiceObject } from "../context/RecoEngineContext";
import ServiceCard from "./ServiceCard";
import useDrag from "../../../utils/useDrag";

interface ServicesRowProps {
  services: Array<ServiceObject>;
}

type ScrollVisibilityApiType = React.ContextType<typeof VisibilityContext>;

const ServicesRow = ({ services }: ServicesRowProps) => {
  const [activeItemID, setActiveItemID] = useState("0");
  const { dragStart, dragStop, dragMove } = useDrag();
  const colors = ["#66EAE1", "#00629D", "#9CDCE7", "#288ECA", "#DDE5ED"]; // Add more as needed

  const handleDrag =
    ({ scrollContainer }: ScrollVisibilityApiType) =>
    (ev: React.MouseEvent) =>
      dragMove(ev, (posDiff) => {
        if (scrollContainer.current) {
          const newScrollLeft = scrollContainer.current.scrollLeft + posDiff;
          scrollContainer.current.scrollLeft = newScrollLeft;
        }
      });

  const handleRenderDots = () => {
    const resultDiv = [];
    let tempClassname = "dot";

    for (let i = 0; i < services.length; i++) {
      if (activeItemID === String(i)) {
        tempClassname = "active dot";
      } else {
        tempClassname = "dot";
      }

      resultDiv.push(<div key={i} className={tempClassname} />);
    }

    return resultDiv;
  };

  return (
    <>
      <div className="recoEngine__row serviceRow">
        <ScrollMenu
          onMouseDown={() => dragStart}
          onMouseUp={() => dragStop}
          onMouseMove={handleDrag}
        >
          {services.map((service, i) => (
            <ServiceCard
              key={`service-${service.id || service.name || i}`}
              colour={colors[i]}
              service={service}
              setActiveItemID={setActiveItemID}
              itemId={String(i)}
            />
          ))}
        </ScrollMenu>
        {services.length > 1 && <div className="dots">{handleRenderDots()}</div>}
      </div>
    </>
  );
};

export default ServicesRow;
